<template>
  <div class="referral">
    <TemplateTable />
  </div>
</template>
<script>
import TemplateTable from "@/components/sms/TemplateTable";
export default {
  components: { TemplateTable },
};
</script>
